export default "__VITE_ASSET__79354247__"